(function() {
    'use strict';

    angular
        .module('sodCommon')
        .factory('MasterLayoutService', MasterLayoutService);

    function MasterLayoutService() {
        var json = {},
            time = new Date();
        return {
            get: get,
            set: set,
            change: change
        };

        function get() {
            return json;
        }

        function set(data) {
            json = data;
            time = new Date();
        }

        function change(){
            return time;
        }
    }
})();